import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { iframeableLogin } from 'app/store/actions/auth.action';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthState } from '../../store/reducers/auth.reducer';
import { IframeAbleService } from './iframeable.service';
import { UserSettings } from 'app/global/user-settings.dto';

@Injectable({ providedIn: 'root' })
export class IFrameAbleGuard {
    /**
     *
     * @param {Router} _router
     * @param store
     */
    constructor(
        private _router: Router,
        private store: Store,
        private iframeableService: IframeAbleService
    ) { }
    waitForDataToLoad(): Observable<AuthState> {
        return this.store.select((state: { auth: AuthState }) => state.auth);
    }
    // canActivate
    async canActivate(route: ActivatedRouteSnapshot) {
        if (Object.prototype.hasOwnProperty.call(route.queryParams, 'token')) {
            const templateId = route.queryParams?.template_id ??  null;
            this.iframeableService.validateToken(decodeURIComponent(route.queryParams.token)).subscribe({
                next: (userData:UserSettings) => {
                    this.store.dispatch(iframeableLogin(userData, templateId));
                    return this.waitForDataToLoad().pipe(map(() => { return true; }));
                },
                error: () => {
                    this._router.navigate(['iframeable/login']);
                    return of(false);
                }
            })
        } else {
            return this._router.navigate(['iframeable/login']);
        }
    }
}
